import { Link } from 'react-router-dom';
import { ThemeButton } from './ThemeWrapper';
import {
  PMA_ACCESS_LEVEL_NAME,
  pmaViaAccessLevelOnly,
  userHasPmaImportPermission,
} from '../utils/pmaUploaderAccess';

export default function PmaUploadersPanel({ users, busyId, error, selectedCount, onToggle }) {
  const staff = (users || []).filter((u) => u.role !== 'admin' && u.role !== 'superadmin');

  return (
    <div className="space-y-4">
      <p className="text-sm theme-text-secondary">
        Select staff who should upload the PMA Excel file and create students. Checking a row
        grants the <strong>PMA student Excel upload</strong> permission. You can also assign the{' '}
        <strong>{PMA_ACCESS_LEVEL_NAME}</strong> access level for Filter Students plus upload.
        Selected users need to sign out and sign in again to see the menu item.
      </p>
      <div className="flex flex-wrap items-center gap-3">
        <span className="text-sm theme-text">
          {selectedCount} selected
        </span>
        <Link to="/admin/pma-student-import">
          <ThemeButton type="button">Open PMA student upload</ThemeButton>
        </Link>
      </div>
      {error && (
        <div
          className="p-3 rounded-lg text-sm"
          style={{ backgroundColor: 'var(--color-error-100)', color: 'var(--color-error)' }}
        >
          {error}
        </div>
      )}
      {staff.length === 0 ? (
        <p className="text-sm theme-text-secondary">
          No trainer, recruiter, or staff users to assign. Create a staff user first.
        </p>
      ) : (
        <ul className="space-y-2">
          {staff.map((u) => {
            const checked = userHasPmaImportPermission(u);
            const viaLevel = pmaViaAccessLevelOnly(u);
            return (
              <li
                key={u.id}
                className="p-3 rounded-lg border flex flex-wrap items-center gap-3"
                style={{ borderColor: 'var(--color-border)' }}
              >
                <label className="flex items-center gap-2 min-w-[220px] flex-1 theme-text cursor-pointer">
                  <input
                    type="checkbox"
                    checked={checked}
                    disabled={busyId === u.id || viaLevel}
                    onChange={(e) => onToggle(u, e.target.checked)}
                  />
                  <span>
                    <span className="font-medium">
                      {u.firstName} {u.lastName}
                    </span>
                    <span className="block text-xs theme-text-secondary">{u.email}</span>
                  </span>
                </label>
                <span className="text-xs theme-text-secondary">{u.role}</span>
                {u.accessLevel?.name && (
                  <span className="text-xs theme-text-secondary">{u.accessLevel.name}</span>
                )}
                {viaLevel && (
                  <span className="text-xs theme-text-secondary">
                    PMA comes from their access level — change the level to revoke
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
